import * as React from "react";
import { userLocation } from "common/data";
import RouteBuilder from "./RouteBuilder";
import { ReactComponent as ChangeRoute } from "./images/change-route.inline.svg";
import styles from "./styles.module.scss";

const BuildARoute = ({ returnValues }) => {
  const [inputFromValue, setInputFromValue] = React.useState("");
  const [inputToValue, setInputToValue] = React.useState(
    `${userLocation.vspu} университет`
  );

  const exchangeValueHandler = () => {
    setInputFromValue(inputToValue);
    setInputToValue(inputFromValue);
  };

  React.useEffect(() => {
    returnValues(inputToValue, inputFromValue);
  }, [inputFromValue, inputToValue]);

  return (
    <div className={styles["build-a-route"]}>
      <RouteBuilder
        text="из"
        value={inputFromValue}
        onChange={setInputFromValue}
      />
      <ChangeRoute
        className={styles["change-route"]}
        onClick={exchangeValueHandler}
      />
      <RouteBuilder
        text="до"
        value={inputToValue} /*onChange={setInputToValue} */
      />
    </div>
  );
};

export default BuildARoute;
